export default "__VITE_ASSET__jKlqxU9W__"